import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';

import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {Store} from '@softline/core';
import {CommandStore, showRequestErrors, SOFTLINE_FEATURE_COMMANDS} from '@softline/application';
import {SOFTLINE_FEATURE_ABSATZPLAN, SOFTLINE_FEATURE_ABSATZPLAN_VERSIONEN} from '../absatzplan.shared';
import {AbsatzplanVersionenStore} from '../store/versionen.store';
import {AbsatzplanStore} from '../store/absatzplan.store';

@Component({
    selector: 'soft-absatzplan-outlet',
    imports: [RouterOutlet],
    templateUrl: './absatzplan.component.html',
    styleUrl: './absatzplan.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export default class AbsatzplanComponent implements OnInit, OnDestroy {

  constructor(
    private readonly store: Store,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.addSet,
      {
        name: AbsatzplanComponent,
        commands: [
          {
            name: '#ABSATZPLAN.MENU.TITLE',
            class: 'menu main-menu main-menu-top title'
          },
          {
            name: '#ABSATZPLAN.MENU.QUERY',
            icon: 'fa-regular fa-plus',
            class: 'menu main-menu main-menu-top',
            routerLink: '/absatzplan/abfrage',
            routerLinkParams: {
              queryParams: !this.activatedRoute.snapshot.queryParamMap.get('query')
                ? null
                : {
                  planvariante: this.activatedRoute.snapshot.queryParamMap.get('planvariante') ?? 'plangruppe',
                  query: this.activatedRoute.snapshot.queryParamMap.get('query') ?? null,
                }
            }
          },
          {
            name: '#ABSATZPLAN.MENU.EINLESEN',
            class: 'menu main-menu main-menu-top',
            routerLink: '/absatzplan/einlesen',
            icon: 'fa-regular fa-file-import'
          },
        ]
      }
    );
/*
    if (this.activatedRoute.snapshot.data['kopfVorhanden']) {
      console.log(this.activatedRoute.snapshot.data['kopfVorhanden'])
      const result = await this.store.dispatch(
        SOFTLINE_FEATURE_MODAL,
        ModalStore.actions.open<KopfVorhandenDialogResult, Record<string, unknown>>(),
        {
          component: KopfVorhandenDialogComponent as never,
          dismiss: false,
          data: {}
        }
      );

      if (result === 'DISMISSED' || result?.action === 'loeschen') {
        await this.store.dispatch(
          SOFTLINE_FEATURE_ABSATZPLAN,
          AbsatzplanStore.actions.deleteVorhandenenKopf
        );
      } else {
        await this.store.dispatch(
          SOFTLINE_FEATURE_ABSATZPLAN,
          AbsatzplanStore.actions.vorhandenenKopfEinlesen
        );
      }
    } */

    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_ABSATZPLAN_VERSIONEN,
        AbsatzplanVersionenStore.actions.loadMany
      );
    } catch (e) {
      showRequestErrors(this.store, e);
    }
  }

  ngOnDestroy(): void {
    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.removeSet,
      AbsatzplanComponent
    );

    this.store.commit(
      SOFTLINE_FEATURE_ABSATZPLAN,
      AbsatzplanStore.mutations.set,
      { loading: false, data: null }
    );
  }
}
